var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3988_5619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6362 1.8184C2.1844 1.8184 1.8184 2.1844 1.8184 2.6362V11.3638C1.8184 11.8156 2.1844 12.1816 2.6362 12.1816H11.3638C11.8156 12.1816 12.1816 11.8156 12.1816 11.3638V2.6362C12.1816 2.1844 11.8156 1.8184 11.3638 1.8184H2.6362ZM11.3638 1C11.7977 1 12.2139 1.17238 12.5208 1.47923C12.8276 1.78608 13 2.20225 13 2.6362V11.3638C13 11.7977 12.8276 12.2139 12.5208 12.5208C12.2139 12.8276 11.7977 13 11.3638 13H2.6362C2.20225 13 1.78608 12.8276 1.47923 12.5208C1.17238 12.2139 1 11.7977 1 11.3638V2.6362C1 2.20225 1.17238 1.78608 1.47923 1.47923C1.78608 1.17238 2.20225 1 2.6362 1L11.3638 1ZM9.373 2.461C9.26447 2.461 9.16039 2.50411 9.08365 2.58085C9.00691 2.65759 8.9638 2.76167 8.9638 2.8702V4C8.9638 4.10853 9.00691 4.21261 9.08365 4.28935C9.16039 4.36609 9.26447 4.4092 9.373 4.4092C9.48153 4.4092 9.58561 4.36609 9.66235 4.28935C9.73909 4.21261 9.7822 4.10853 9.7822 4V2.8702C9.7822 2.76167 9.73909 2.65759 9.66235 2.58085C9.58561 2.50411 9.48153 2.461 9.373 2.461ZM2.6464 1.564L3.4642 1.5676L3.4516 4.2352C3.4336 4.4788 3.5116 4.6756 3.7006 4.8574C3.8884 5.038 4.147 5.1202 4.531 5.0974L9.706 5.0998C9.9952 5.0668 10.1986 4.972 10.336 4.8184C10.4728 4.6642 10.5436 4.4566 10.543 4.1746V1.5652H11.3614V4.1734C11.362 4.6468 11.2252 5.0494 10.9462 5.3626C10.6672 5.6758 10.2778 5.8576 9.7522 5.9146H4.5562C3.9808 5.95 3.4972 5.7964 3.1336 5.4466C2.7712 5.0986 2.5996 4.6642 2.6344 4.2034L2.6464 1.564Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3988_5619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.bb738169c19e45b4c0ea2b5476812921.svg";
export { ForwardRef as ReactComponent };